<template>
  <bar-chart :chartdata="chartdata" :options="options"/>
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'BackupSummaryTotal',
  components: {
    BarChart
  },
  props: {
    totals: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => [
        'ami',
        'rds',
        'aurora',
        'ebs',
        'redshift',
        'documentdb',
        's3'
      ]
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: this.labels,
        datasets: [
          {
            label: 'totals',
            backgroundColor: '#2185D5',
            data: this.totals
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupSummaryTotal.vue